
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-leadership",
      function () {
        return require("private-next-pages/our-leadership/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-leadership"])
      });
    }
  